export default "__VITE_ASSET__e0a5ab88__"